// extracted by mini-css-extract-plugin
export default {"autocomplete-dropdown":"MappingView_autocomplete-dropdown__ePNBP","autocompleteDropdown":"MappingView_autocomplete-dropdown__ePNBP"};